export const FULL_ADDRESS_ADDRESS_PREFERENCE = 'FULL_ADDRESS'
export const CITY_STATE_COUNTRY_ADDRESS_PREFERENCE = 'CITY_STATE_COUNTRY'
export const STATE_COUNTRY_ADDRESS_PREFERENCE = 'STATE_COUNTRY'
export const DO_NOT_SHOW_ADDRESS_PREFERENCE = 'DO_NOT_SHOW'
